import type { Subscription } from '@viome/viome-base/src/usecase/Misc/MiscModel';
import { resolveComponentizationEligibleSkus } from '@/constants/componentizationSkus';

export const isEligibleForComponentization = (
  subscription: Pick<Subscription, 'sku'>,
  eligibleSkus?: string[] | null,
) =>
  resolveComponentizationEligibleSkus(eligibleSkus).includes(subscription?.sku);
